import React, { createContext, useState } from 'react';

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [activeNotification, setActiveNotification] = useState({
    documentIsFinal: null,
    path: null,
    referenceId: null,
    referenceType: null,
    workflowGroupId: null,
    workflowId: null,
  });

  // A helper function to update all or part of the notification context
  const updateNotificationContext = (newData) => {
    setActiveNotification(prev => ({ ...prev, ...newData }));
  };

  return (
    <NotificationContext.Provider value={{ activeNotification, updateNotificationContext }}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContext;